import { environment } from '@upkey-platform/core/core-shared'

export const RESUME_API_URL = {
  getResumes: `${environment.apiUrl}/resumes`,
  resume: `${environment.apiUrl}/resumes`
}
